import {
  Divider,
  Form,
  Typography,
  Upload,
  Select,
  Input,
  Row,
  Col,
  Button,
} from "antd";
import React from "react";
import { useFormik } from "formik";
import { InboxOutlined } from "@ant-design/icons";
import PageHeader from "../../PageHeader";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";

const { Title, Text } = Typography;

const { Dragger } = Upload;
const { Option } = Select;
const { TextArea } = Input;

const AddNewOrg = () => {
  const history = useHistory();
  const [countriesData] = React.useState([]);
  const [uploadLogoData, setUploadLogoData] = React.useState({});
  const [uploadIncorpData, setUploadIncorpData] = React.useState({});
  const [uploadOtherData, setUploadOtherData] = React.useState({});
  const [stateData] = React.useState("");
  const [cityData] = React.useState("");
  const [statesData] = React.useState([]);
  const [citiesData] = React.useState([]);
  const [incorporationUrl] = React.useState("");
  const [logoUrl] = React.useState("");
  const [otherUrl] = React.useState("");
  const dispatch = useDispatch();
  const formik = useFormik({
    initialValues: {
      org_name: "",
      primary_email: "",
      primary_contact: "",
      name: "",
    },
    onSubmit: (vals) => {
      dispatch({
        type: "ORG_VALS",
        payload: vals,
      });
      history.push("/setting/organisation/manage");
    },
  });

  const onFileChange = (info, name) => {
    const nextState = {};
    switch (info.file.status) {
      case "uploading":
        nextState.selectedFileList = [info.file];
        break;
      case "done":
        nextState.selectedFile = info.file;
        nextState.selectedFileList = [info.file];
        break;

      default:
        // error or removed
        nextState.selectedFile = null;
        nextState.selectedFileList = [];
    }
    switch (name) {
      case "logo":
        setUploadLogoData(nextState);
        break;
      case "incorporation":
        setUploadIncorpData(nextState);
        break;
      case "other":
        setUploadOtherData(nextState);
        break;
      default:
        break;
    }
  };

  return (
    <>
      <div className="heading-div">
        <PageHeader
          title={`Add Branch`}
          navigation={{
            Home: "/dashboard/",

            "Add Branch": null,
          }}
        />
      </div>
      <div className="contentWrapper">
        <Title level={5}>Branch Address</Title>
        <Divider />
        <Form
          layout="vertical"
          onFinish={formik.handleSubmit}
          className="settings_form"
        >
          <Row>
            <Col span={12}>
              <Form.Item label="Branch Name" name="org_name">
                <Input
                  placeholder="Branch Name"
                  name="org_name"
                  onChange={formik.handleChange}
                />
              </Form.Item>
              <Form.Item label="Branch Registration No" name="registration_no">
                <Input placeholder="Branch Registration No" />
              </Form.Item>
              <Form.Item label="Address" name="address">
                <TextArea
                  // value={value}
                  // onChange={this.onChange}
                  placeholder="Enter Address"
                  autoSize={{ minRows: 3, maxRows: 5 }}
                />
              </Form.Item>
            </Col>
            <Col span={12} className="uploadSection">
              <Text>Upload your company logo</Text>
              {logoUrl && <img alt="" src={logoUrl} className="orgaImage" />}
              <Dragger
                fileList={uploadLogoData.selectedFileList}
                // customRequest={dummyRequest}
                name="logo"
                onChange={(evt) => onFileChange(evt, "logo")}
              >
                <p className="ant-upload-text">
                  <InboxOutlined />
                  Drag here to upload JPG/PNG
                  <br />
                  Or click here to attach
                </p>
              </Dragger>
              <p className="hint">
                Preferred Image Size: 240px x 240px @ 72 DPI Maximum size of
                1MB.
              </p>
            </Col>
          </Row>
          <Row>
            <Col span={6}>
              <Form.Item label="Country" name="country_id">
                <Select
                  style={{ width: 200 }}
                  placeholder="Select Country"
                // onChange={(val) => handleCountryData(val)}
                // value={countryData}
                >
                  {countriesData &&
                    countriesData.map(({ id, name }) => (
                      <Option key={id} value={id}>
                        {name}
                      </Option>
                    ))}
                </Select>
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item label="State" name="state_id">
                <Select
                  style={{ width: 200 }}
                  placeholder="Select State"
                  // onChange={(val) => handleStateData(val)}
                  // disabled={!form.getFieldValue("country_id")}
                  value={stateData}
                >
                  {statesData &&
                    statesData.map(({ id, name }) => (
                      <Option key={id} value={id}>
                        {name}
                      </Option>
                    ))}
                </Select>
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item label="City" name="city_id">
                <Select
                  style={{ width: 200 }}
                  placeholder="Select City"
                  // onChange={(val) => handleCityData(val)}
                  // disabled={!form.getFieldValue("state_id")}
                  value={cityData}
                >
                  {citiesData &&
                    citiesData.map(({ id, name }) => (
                      <Option key={id} value={id}>
                        {name}
                      </Option>
                    ))}
                </Select>
              </Form.Item>
            </Col>

            <Col span={6}>
              <Form.Item label="Pincode" name="pincode">
                <Input placeholder="Pincode" />
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col span={8}>
              <Form.Item label="Office Number" name="office_no">
                <Input placeholder="Office Number" />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item label="GSTIN No" name="gst_no">
                <Input placeholder="GSTIN No" />
              </Form.Item>
            </Col>
            <Col span={9}>
              <Form.Item label="TAN No" name="tan_no">
                <Input placeholder="TAN No" />
              </Form.Item>
            </Col>
          </Row>
          <Text>Upload your company documents</Text>
          <Row className="mt1">
            <Col span={12} className="uploadSectionSmall">
              <Text>Certificate of Incorporation</Text>
              {incorporationUrl && (
                <img alt="" src={incorporationUrl} className="orgaImage" />
              )}
              <Dragger
                fileList={uploadIncorpData.selectedFileList}
                // customRequest={dummyRequest}
                onChange={(evt) => onFileChange(evt, "incorporation")}
                name="incorporation"
              >
                <p className="ant-upload-text">
                  <InboxOutlined />
                  Drag here to upload JPG/PNG
                  <br />
                  Or click here to attach
                </p>
              </Dragger>
            </Col>
            <Col span={12} className="uploadSectionSmall">
              <Text>Other documents (GST Certificate,TAN)</Text>
              {otherUrl && <img alt="" src={otherUrl} className="orgaImage" />}
              <Dragger
                name="other"
                fileList={uploadOtherData.selectedFileList}
                // customRequest={dummyRequest}
                onChange={(evt) => onFileChange(evt, "other")}
              >
                <p className="ant-upload-text">
                  <InboxOutlined />
                  Drag here to upload JPG/PNG
                  <br />
                  Or click here to attach
                </p>
              </Dragger>
            </Col>
          </Row>
          <Title level={5} className="mt2">
            Corporate Admin
          </Title>
          <Divider />
          <Row>
            <Col span={10}>
              <Form.Item label="Contact Name" name="name">
                <Input
                  placeholder="Contact Name"
                  name="name"
                  onChange={formik.handleChange}
                />
              </Form.Item>
            </Col>
            <Col span={10}>
              <Form.Item
                label="Contact Email"
                name="primary_email"
              >
                <Input
                  placeholder="Contact Email"
                  name="primary_email"
                  onChange={formik.handleChange}
                />
              </Form.Item>
            </Col>
            <Col span={10}>
              <Form.Item label="Contact Number" name="primary_phone">
                <Input
                  placeholder="Contact Number"
                  name="primary_contact"
                  onChange={formik.handleChange}
                />
              </Form.Item>
            </Col>
          </Row>
          <Title level={5} className="mt2">
            Regional Settings
          </Title>
          <Divider />
          <Row>
            <Col span={12}>
              <Form.Item label="Base Currency" name="base_currency">
                <Input placeholder="Base Currency" />
              </Form.Item>
              <Form.Item label="Time Zone" name="time_zone">
                <Input placeholder="Time Zone" />
              </Form.Item>
              <Form.Item label="Fiscal Year" name="fiscal_year">
                <Input placeholder="Fiscal Year" />
              </Form.Item>
            </Col>
          </Row>
          <Button
            key="1"
            htmlType="submit"
            className="formButton mt1 primaryButton"
          >
            Save
          </Button>
          <Button
            key="2"
            className="cancelButton ml1 mt1"
          // onClick={() => props.handleCancel()}
          >
            Cancel
          </Button>
        </Form>
      </div>
    </>
  );
};

export default AddNewOrg;
